<template>
  <span>
    <span v-if=" !revealAnswers"
      class="clex-keyword"
      v-scroll-in-view-when="active"
      v-bind:class="{active, answered}"
      v-on:click.prevent="select">{{visibleContent}}</span>

    <span v-else
      class="clex-keyword answer"
      v-bind:class="{correct: answerIsCorrect, wrong: !answerIsCorrect}"
      v-html="answerDiff"></span>
  </span>
</template>

<script>

import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
export default {

  beforeMount() {
    // Grab the slot and replace it with placeholder
    // console.log(`<keyword> created ${this._uid}`)

    // Self register
    // console.log(`keyword ${this._uid} is registering`)

    // console.log(this._uid)
    const realAnswer = this.$slots.default[0].text;
    const length = realAnswer.length;
    let placeholder = "*".repeat(length)

    const keywordData = {
      _uid: this._uid,
      placeholder,
      realAnswer, //~=innerHTML
      answer: null,
      answered: false,
      correct: false,
    }

    // Each keyword register's itself with the store so that they're linked
    this.$store.commit('studier/REGISTER_KEYWORD', {
      keyword: keywordData,
    })

  },

  methods: {
    select() {
      this.$store.dispatch('studier/setActiveKeyword', {keyword: this.keyword})
    },
  },


  computed: {
    ...mapGetters({
      revealAnswers: 'studier/microNoteIsCompleted',
      chapter: 'studier/chapter',
    }),

    ...mapState({
      keywords: (state) => {
        return state.studier.keywords;
      },
    }),

    // Determines what is displayed in the keyword
    visibleContent() {
      if (this.answer) { return this.answer; }

      let a = '';
      if (!this.chapter || !this.chapter.KeywordDifficulty || this.chapter.KeywordDifficulty == 1) {
        for (let char of this.realAnswer) {
          a += char === ' ' ? ' ' : '*' ;
        }
      } else if (this.chapter.KeywordDifficulty == 2) {
        a = "----- ".repeat(this.realAnswer.split(' ').length).trim();
      } else {
        a = " ? ";
      }
      return a;
    },

    // Highlights errors in red, including misspelling
    answerDiff() {
      if( !this.answer || !this.realAnswer) return '';
      const answer = this.answer.trim().toLowerCase();
      const realAnswer = this.realAnswer.trim().toLowerCase();

      if(answer === realAnswer) return `<span>${this.answer}</span>`;
      let html = '';

      let answerArr = answer.split('');
      let realAnswerArr = realAnswer.trim().split('');

      // console.log(realAnswerArr);

      while(realAnswerArr.length || answerArr.length) {
        const x = answerArr.shift() || '';
        const y = realAnswerArr.shift() || '';
        const char = y || x;

        if(x === y) {
          html = html + char;
        } else {
          html = html + `<span class="mistake">${char}</span>`;
        }
      }
      // console.log(`html= ${html}`);
      return html;
    },

    answerIsCorrect() {
      return this.keyword ? this.keyword.correct : false;
    },

    // Keyword finds its data doppleganger from the store
    keyword() {
      // {
      //   realAnswer: 'whatever',
      //   answer: null,
      //   placeholder: '_______',
      //   active: false,
      //   answered: false,
      // }
      return this.keywords[this._uid];
    },

    // Whether or not the answer has been "submitted" for this keyword
    // ie. if user is in middle of typing it is technically not answered yet
    answered() {
      // console.log(this.keyword.answered)
      return this.keyword ? this.keyword.answered : false;
    },

    answer() {
      return this.keyword ? this.keyword.answer : null;
    },

    realAnswer() {
      return this.keyword ? this.keyword.realAnswer : null;
    },

    placeholder() {
      return this.keyword ? this.keyword.placeholder : null;
    },

    active() {
      if(this._uid === this.$store.state.studier.currentKeywordUID) {
        return true;
      } else {
        return false;
      }
    },
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

/**
 * keyword is in the editor form, and .clex-keyword
 * is it's vue-component-rendered form (study mode)
 */

.clex-keyword {
  // background: #fcd45e;
  background: orange;
  padding: 3px 5px;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;

  &.answer {
    background: none;
    color: #4285f4;
  }

  .mistake {
    color: red;
  }

  &.answer.correct {
    color: #37b358;
    /*color: white;*/
  }

  &.answered {
    // background: orange;
    background: #fcd45e;
  }

  &.active {
    background: #37b358;
    /*background: #4285f4;*/
    color: white;
  }
}

</style>



// WEBPACK FOOTER //
// Keyword.vue?6e5eb47b